import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate, RouterStateSnapshot
} from '@angular/router';
import { TeCuidamosHelper } from '@core/services/helpers/teCuidamos-helper.service';
import { NavController } from '@ionic/angular';

@Injectable({
  providedIn: 'root'
})
export class ClubMapfreGuard implements CanActivate {

  constructor(
    private tecuidamosHelper: TeCuidamosHelper,
    private nav: NavController
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const redirectTo = route.queryParams?.redirect;
    if (redirectTo) {
      this.tecuidamosHelper.openSaviaTeCuidamosUrl('teCuidamos', redirectTo);
    }
    return true;
  }

}